const r = ":host{display:block}.sl-tabs{display:flex;flex-direction:column}.sl-tabs__nav{display:flex;gap:var(--sl-spacing-1);border-bottom:1px solid hsl(var(--sl-hsl-border));overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none}.sl-tabs__nav::-webkit-scrollbar{display:none}.sl-tabs__content{margin-top:var(--sl-spacing-4)}";
class o extends HTMLElement {
  constructor() {
    super(), this._activeTab = null, this._keydownHandler = null, this._tabClickHandlers = /* @__PURE__ */ new Map(), this._shadow = this.attachShadow({ mode: "open" }), this._nav = document.createElement("nav"), this._render();
  }
  static get observedAttributes() {
    return ["active"];
  }
  connectedCallback() {
    this._setupTabs(), this._setupKeyboardNavigation();
  }
  disconnectedCallback() {
    this._nav && this._keydownHandler && (this._nav.removeEventListener("keydown", this._keydownHandler), this._keydownHandler = null), this._tabClickHandlers.forEach((t, e) => {
      e.removeEventListener("sl-tab-click", t);
    }), this._tabClickHandlers.clear();
  }
  attributeChangedCallback(t, e, s) {
    e !== s && s !== null && this._setActiveTab(s);
  }
  get active() {
    return this.getAttribute("active");
  }
  set active(t) {
    t ? this.setAttribute("active", t) : this.removeAttribute("active");
  }
  _setActiveTab(t) {
    this._activeTab = t, this.setAttribute("active", t);
    const e = this.querySelectorAll("sl-tab"), n = (this.parentElement ?? document).querySelectorAll("sl-tab-content");
    e.forEach((i) => {
      const a = i;
      a.getAttribute("name") === t ? a.setAttribute("active", "") : a.removeAttribute("active");
    }), n.forEach((i) => {
      const a = i;
      a.getAttribute("name") === t ? a.setAttribute("active", "") : a.removeAttribute("active");
    }), this.dispatchEvent(
      new CustomEvent("sl-tab-change", {
        bubbles: !0,
        composed: !0,
        detail: { tab: t }
      })
    );
  }
  show(t) {
    this._setActiveTab(t);
  }
  _setupTabs() {
    const t = this.querySelectorAll("sl-tab");
    if (this.active)
      this._setActiveTab(this.active);
    else if (t.length > 0) {
      const s = t[0].getAttribute("name");
      s && this._setActiveTab(s);
    }
    t.forEach((e) => {
      const s = (n) => {
        const l = n.detail.tab.getAttribute("name");
        l && this._setActiveTab(l);
      };
      e.addEventListener("sl-tab-click", s), this._tabClickHandlers.set(e, s);
    });
  }
  _setupKeyboardNavigation() {
    this._keydownHandler = (t) => {
      const e = Array.from(this.querySelectorAll("sl-tab:not([disabled])")), s = e.findIndex(
        (l) => l.getAttribute("name") === this._activeTab
      );
      if (s === -1) return;
      let n = s;
      switch (t.key) {
        case "ArrowRight":
          t.preventDefault(), n = (s + 1) % e.length;
          break;
        case "ArrowLeft":
          t.preventDefault(), n = (s - 1 + e.length) % e.length;
          break;
        case "Home":
          t.preventDefault(), n = 0;
          break;
        case "End":
          t.preventDefault(), n = e.length - 1;
          break;
        default:
          return;
      }
      const i = e[n], a = i.getAttribute("name");
      a && (this._setActiveTab(a), i.focus());
    }, this._nav.addEventListener("keydown", this._keydownHandler);
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${r}</style>
      <nav class="sl-tabs__nav" part="nav" role="tablist">
        <slot></slot>
      </nav>
    `, this._nav = this._shadow.querySelector("nav");
  }
}
typeof customElements < "u" && !customElements.get("sl-tabs") && customElements.define("sl-tabs", o);
export {
  o as SlTabsElement
};
//# sourceMappingURL=sl-tabs.js.map
